
    export function validate (xml) {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(xml, "application/xml");
            const errNode = doc.getElementsByTagName("parsererror")[0];
            return errNode ? (errNode.textContent || "XML parse error") : null;
        } catch (e) {
            return e?.message || "XML parse error";
        }
    };

    export function format (xml, indent = "  ") {
        if (!xml) return "";

        // normalize newlines, then split tags onto separate lines
        const src = String(xml)
            .replace(/\r\n/g, "\n")
            .replace(/>\s*</g, ">\n<")
            .trim();

        const lines = src.split("\n");
        let pad = 0;

        const isClosingTag = (s) => /^<\/[^>]+>/.test(s);
        const isOpeningTag = (s) =>
            /^<[^!?/][^>]*>/.test(s) && !/\/>$/.test(s) && !/^<[^>]+>.*<\/[^>]+>$/.test(s);
        const isSelfClosing = (s) => /\/>$/.test(s);
        const isSpecial = (s) => /^<(\?xml|!DOCTYPE|!--|\?)/.test(s);

        const out = [];
        for (let raw of lines) {
            const line = raw.trim();
            if (!line) continue;

            if (!isSpecial(line) && isClosingTag(line)) pad = Math.max(pad - 1, 0);

            out.push(indent.repeat(pad) + line);

            if (!isSpecial(line) && isOpeningTag(line) && !isSelfClosing(line)) pad += 1;
        }

        return out.join("\n");
    };
